import { render } from "./cp_school_tag.vue?vue&type=template&id=c3ee8e6a&scoped=true"
import script from "./cp_school_tag.vue?vue&type=script&lang=js"
export * from "./cp_school_tag.vue?vue&type=script&lang=js"

import "./cp_school_tag.vue?vue&type=style&index=0&id=c3ee8e6a&scoped=scope&lang=less"

import exportComponent from "E:\\WorkCode\\HZYNew\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3ee8e6a"]])

export default __exports__